import { api } from './client'

export interface DiscountRule {
    id: string
    customer_group_id: string
    product_id: string
    discount_percent: number
    product_name?: string
    created_at: string
    updated_at: string
}

export const discountRuleApi = {
    list: (groupId: string) =>
        api.get<DiscountRule[]>(`/customer-groups/${groupId}/discount-rules`),
    create: (
        groupId: string,
        data: { product_id: string; discount_percent: number },
    ) =>
        api.post<DiscountRule>(
            `/customer-groups/${groupId}/discount-rules`,
            data,
        ),
    update: (groupId: string, id: string, data: { discount_percent: number }) =>
        api.put<DiscountRule>(
            `/customer-groups/${groupId}/discount-rules/${id}`,
            data,
        ),
    delete: (groupId: string, id: string) =>
        api.delete(`/customer-groups/${groupId}/discount-rules/${id}`),
}
